import { render, staticRenderFns } from "./CircledAvatar.vue?vue&type=template&id=5005e61c&scoped=true&"
import script from "./CircledAvatar.vue?vue&type=script&lang=ts&"
export * from "./CircledAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./CircledAvatar.vue?vue&type=style&index=0&id=5005e61c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5005e61c",
  null
  
)

export default component.exports